import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Option, Loader } from '@inplayer-org/inplayer-ui';

// actions
import { fetchAdminMerchantDetails, resetAdminMerchantDetailsState } from 'ducks/adminDucks/merchants/actions';

// selectors
import { getAdminMerchantState } from 'ducks/adminDucks/merchants/selectors';

// components
import GenericTable from 'components/Table/GenericTable';
import Filter from 'components/Filter';
import SearchTooltip from 'components/SearchTooltip';
import CreateUpdateClientAgentForm, { OwnProps as ClientFormProps } from '../forms/CreateUpdateClientForm';

const { Container, Cell } = Grid;

const options: Array<Option> = [{ value: 'AccountID', displayName: 'Account ID' }];
interface SearchParams {
  AccountID: number;
}

type OwnProps = {
  addMerchantMode: boolean;
};

type Props = ClientFormProps & OwnProps;

const UpdateExistingMerchantModal = ({
  addMerchantMode,
  editMode,
  follower,
  followerMethods,
  handleCloseModal,
  isFetching,
  noMethods,
  onSubmit,
  paymentMethods,
  scopeOptions,
}: Props) => {
  const [tags, setTags] = useState<SearchParams>({ AccountID: 0 });
  const [resetFilter, setResetFilter] = useState(true);
  const dispatch = useDispatch();
  const merchantsState = useSelector(getAdminMerchantState);
  const {
    details: { isFetching: isMerchantFetching },
  } = merchantsState;

  const { id: merchantId, email: merchantEmail } = merchantsState.details.account;

  const handleAddTag = (searchParams: SearchParams) => {
    dispatch(resetAdminMerchantDetailsState());
    if (!resetFilter) {
      setResetFilter(true);
    }
    setTags(searchParams);
  };

  useEffect(() => {
    dispatch(fetchAdminMerchantDetails(tags.AccountID));
  }, [tags.AccountID]);

  const renderTableHeaderSection = () => {
    return (
      <Container>
        <Cell width={12}>
          <SearchTooltip />
        </Cell>
        <Cell width={12}>
          <Filter options={options} onSearch={handleAddTag} />
        </Cell>
      </Container>
    );
  };
  return (
    <>
      <GenericTable
        columns={[]}
        data={[]}
        renderEmptyTable
        options={{
          headerSection: renderTableHeaderSection(),
        }}
      />
      {isMerchantFetching ? (
        <Loader />
      ) : (
        merchantEmail &&
        resetFilter && (
          <CreateUpdateClientAgentForm
            merchantId={merchantId}
            merchantEmail={merchantEmail}
            addMerchantMode={addMerchantMode}
            scopeOptions={scopeOptions}
            isFetching={isFetching}
            handleCloseModal={handleCloseModal}
            onSubmit={onSubmit}
            paymentMethods={paymentMethods}
            followerMethods={followerMethods}
            isMethodsFetching={isFetching}
            follower={follower}
            editMode={editMode}
            noMethods={noMethods}
          />
        )
      )}
    </>
  );
};

export default UpdateExistingMerchantModal;
